import { Sparkles } from "lucide-react";

const TOKENS = [
  "LINK SHORTENING",
  "LINK-IN-BIO PAGES",
  "SMART ROUTING",
  "REAL-TIME ANALYTICS",
  "BRANDED QR CODES",
  "CAMPAIGNS & UTM",
  "WEBHOOKS & API",
  "AI ASSISTS",
  "CUSTOM DOMAINS",
  "BUILT FOR CREATORS",
];

/** LandingMarquee — scrolling platform-capability ticker. */
export default function LandingMarquee() {
  return (
    <div className="overflow-hidden border-b-2 border-ink bg-candy text-white" data-testid="ticker">
      <div className="marquee-track py-3.5">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center gap-8 whitespace-nowrap pr-8">
            {TOKENS.map((w, i) => (
              <span
                key={`${k}-${i}`}
                className="flex items-center gap-3 font-mono text-[11px] font-bold uppercase tracking-[0.28em]"
              >
                <Sparkles size={11} strokeWidth={3} /> {w}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
